export default __webpack_public_path__ + "static/media/fondo-negro.9316e677.svg";